import { X, ArrowRight } from "lucide-react";

export default function AmazonFallbackCard({ q, result, onClose }) {
  return (
    <div className="hpz-amazon-fb" data-testid="plaza-amazon-fallback">
      <button className="hpz-amazon-fb__close"
               onClick={onClose}
               aria-label="Dismiss"
               data-testid="plaza-amazon-fallback-close">
        <X size={18} />
      </button>
      <div className="hpz-amazon-fb__label">
        Couldn&apos;t find &ldquo;{q}&rdquo; in our catalogue?
        <span> We checked Amazon for you</span>
      </div>
      <div className="hpz-amazon-fb__card">
        {result.image_url && (
          <img src={result.image_url} alt={result.title || "Amazon listing"}
                className="hpz-amazon-fb__img"
                data-testid="plaza-amazon-fallback-img" />
        )}
        <div className="hpz-amazon-fb__body">
          <p className="hpz-amazon-fb__title"
              data-testid="plaza-amazon-fallback-title">
            {result.title || "View on Amazon"}
          </p>
          {result.price_cents > 0 && (
            <p className="hpz-amazon-fb__price">
              ${(result.price_cents / 100).toFixed(2)} on Amazon AU
            </p>
          )}
          <a href={result.url}
              target="_blank" rel="noopener noreferrer sponsored"
              className="hpz-amazon-fb__btn"
              data-testid="plaza-amazon-fallback-buy">
            Buy on Amazon
            <ArrowRight size={14} />
          </a>
          <p className="hpz-amazon-fb__disclaim">
            Affiliate link — we earn a small commission at no extra cost
            to you, which helps keep HustlePlaza free.
          </p>
        </div>
      </div>
    </div>
  );
}
